/**
 * Font service — loads custom fonts via the browser FontFace API.
 * Fonts are served statically from public/fonts/ so webpack never
 * tries to resolve their URLs at build time.
 *
 * To add a new font, just push an entry to the FONTS array below.
 */

const FONTS = [
  {
    family: 'Open Sans',
    url: '/fonts/OpenSans-VariableFont_wdth,wght.ttf',
    weight: '100 900',
    style: 'normal',
  },
];

export function initFonts() {
  FONTS.forEach(({ family, url, weight, style }) => {
    const face = new FontFace(family, `url(${url})`, { weight, style });
    face.load().then(() => {
      document.fonts.add(face);
    });
  });
}
